import Vue from "vue";
import VueRouter from "vue-router";
import BaseRoutes from "@/router/BaseRoutes";
import AuthRoutes from "@/router/AuthRoutes";

import StorageHelper from "@/helpers/storage";
import profileController from "@/controllers/v2/profileController";
import answerController from "@/controllers/v2/answerController";
import questionnaireController from "@/controllers/v2/questionnairesController";
import recommendationController from "@/controllers/v2/recommendationController";
import learningContentsController from "@/controllers/v2/learningContentsController";

Vue.use(VueRouter);

const routes = [];

routes.push(...BaseRoutes);
routes.push(...AuthRoutes);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const tokens = StorageHelper.loadState("tokens");
  const isAuthenticated = !!tokens;
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    next("/login");
  } else {
    next();
  }
});

console.log({profileController, answerController, questionnaireController, recommendationController, learningContentsController})

export default router;
